import React, { useContext, useState } from "react";
import { Card, CardHeader, Col, Row } from "reactstrap";
import ViewOfferSubTabs from "./ViewOfferSubTabs";
import { VIEW_OFFER_TABS } from "./constants/initialValues";
import { ViewOfferContext } from "./context";
import ViewOfferChargesRecurring from "./ViewOfferChargesRecurring";
import ViewOfferChargesOneTime from "./ViewOfferChargesOneTime";

const ViewOfferCharges = ({ activeTab, setActiveTab }) => {
  const { values } = useContext(ViewOfferContext);

  return (
    <Row className="mb-4">
      <Col lg={12}>
        {/* <ViewOfferSubTabs activeTab={activeTab} setActiveTab={setActiveTab} /> */}

        {/* {activeTab === VIEW_OFFER_TABS.RECURRING ? ( */}
          <ViewOfferChargesRecurring
            chargesRecurringList={values?.recurringCharges || []}
          />
        {/* ) : (
          <ViewOfferChargesOneTime chargesOneTimeList={values?.charges || []} />
        )} */}
      </Col>
    </Row>
  );
};

export default ViewOfferCharges;
